// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-width{min-width:160px!important;max-width:160px!important;-webkit-box-flex:0!important;-ms-flex:0 0 1px!important;flex:0 0 1px!important}", ""]);
// Exports
module.exports = exports;
